import { render, staticRenderFns } from "./waitCoinsList.vue?vue&type=template&id=51804bd8&scoped=true&"
import script from "./waitCoinsList.vue?vue&type=script&lang=js&"
export * from "./waitCoinsList.vue?vue&type=script&lang=js&"
import style0 from "./waitCoinsList.vue?vue&type=style&index=0&id=51804bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51804bd8",
  null
  
)

export default component.exports